module.exports = __webpack_public_path__ + "static/img/fbs2.f0ebf2e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/fbs2.webp
// module id = dGUS
// module chunks = 1